<template>
  <div>
    <validationObserver ref="addDataForm" tag="form">
      <form>
        <!-- <b-form-group
          label="Root"
          label-for="input_root"
          label-cols-sm="3"
          v-if="componentModel.level !== 1"
        >
          <label class="col-form-label col-sm-7">{{
            componentModel.root
          }}</label>
        </b-form-group> -->
        <b-form-group
          label="ประเภท"
          label-for="type"
          label-cols-sm="3"
          v-if="componentModel.level !== 1"
        >
          <label class="col-form-label col-sm-7">{{
            componentModel.type
          }}</label>
        </b-form-group>
        <b-form-group
          label="รหัส (OFM)"
          label-for="input_code"
          label-cols-sm="3"
        >
          <label class="col-form-label col-sm-7">{{
            componentModel.code
          }}</label>
        </b-form-group>
        <validationProvider
          v-slot="{ errors }"
          name="Thai Name"
          :rules="{
            dynamicRequired: ['กรุณาระบุชื่อหมวดหมู่เป็นภาษาไทย'],
            duplicateName: [
              isValidate.display_name_th,
              'ชื่อหมวดหมู่ภาษาไทยซ้ำกับข้อมูลที่อยู่ในระบบ',
            ],
          }"
        >
          <div class="form-row form-group">
            <label class="col-sm-3 col-form-label">ชื่อ (ไทย)</label>
            <div class="col-sm-9">
              <div class="input-group">
                <input
                  id="input_displayname_th"
                  name="input_displayname_th"
                  type="text"
                  class="form-control"
                  placeholder="ระบุชื่อหมวดหมู่ภาษาไทย"
                  v-model="componentModel.display_name.th"
                  maxlength="50"
                  :class="{
                    'is-invalid': errors && errors.length,
                    'is-valid':
                      !(errors && errors.length) &&
                      componentModel.display_name.th,
                  }"
                  v-on:keyup="onValidateDisplaynameTH($event)"
                />
                <span class="input-group-append">
                  <span class="input-group-text"
                    >{{ componentModel.display_name.th.length }}/50
                  </span>
                </span>
              </div>
              <div v-if="errors && errors.length" class="validate-invalid">
                <span>{{ errors[0] }}</span>
              </div>
            </div>
          </div>
        </validationProvider>
        <validationProvider
          v-slot="{ errors }"
          name="English Name"
          :rules="{
            dynamicRequired: ['กรุณาระบุชื่อหมวดหมู่เป็นภาษาอังกฤษ'],
            duplicateName: [
              isValidate.display_name_en,
              'ชื่อหมวดหมู่ภาษาอังกฤษซ้ำกับข้อมูลที่อยู่ในระบบ',
            ],
            validateEngWithSpecialCharacters: true,
          }"
        >
          <div class="form-row form-group">
            <label class="col-sm-3 col-form-label">ชื่อ (อังกฤษ)</label>
            <div class="col-sm-9">
              <div class="input-group">
                <input
                  id="input_displayname_en"
                  name="input_displayname_en"
                  type="text"
                  class="form-control"
                  placeholder="ระบุชื่อหมวดหมู่ภาษาอังกฤษ"
                  v-model="componentModel.display_name.en"
                  maxlength="50"
                  :class="{
                    'is-invalid': errors && errors.length,
                    'is-valid':
                      !(errors && errors.length) &&
                      componentModel.display_name.en,
                  }"
                  v-on:keyup="onValidateDisplaynameEN($event)"
                />
                <span class="input-group-append">
                  <span class="input-group-text"
                    >{{ componentModel.display_name.en.length }}/50
                  </span>
                </span>
              </div>
              <div v-if="errors && errors.length" class="validate-invalid">
                <span>{{ errors[0] }}</span>
              </div>
            </div>
          </div>
        </validationProvider>
        <b-form-group
          label="ประเภท"
          label-for="input_type"
          label-cols-sm="3"
          v-if="componentModel.level === 1"
        >
          <div class="row col-sm-9 col-form-label">
            <b-form-radio
              v-model="componentModel.type"
              name="input_type"
              class="custom-control custom-radio custom-radio-info mb-3"
              value="OFMStock"
              style="margin-right: 10px"
              >OFMStock</b-form-radio
            >
            <b-form-radio
              v-model="componentModel.type"
              name="input_type"
              class="custom-control custom-radio custom-radio-info mb-3"
              value="DropShip"
              >DropShip</b-form-radio
            >
          </div>
        </b-form-group>
        <validationProvider
          v-if="componentModel.level === 2"
          v-slot="{ errors }"
          name="Product Line"
          :rules="{
            dynamicRequired: ['กรุณาระบุ Product Line'],
          }"
        >
          <b-form-group
            label="Product Line"
            label-for="input_product_line"
            label-cols-sm="3"
          >
            <b-form-input
              id="input_product_line"
              type="text"
              v-model="componentModel.product_line"
              placeholder="ระบุ Product Line"
              maxlength="2"
              :class="{
                'is-invalid': errors && errors.length,
                'is-valid':
                  !(errors && errors.length) && componentModel.product_line,
              }"
            ></b-form-input>
            <div v-if="errors && errors.length" class="validate-invalid">
              <span>{{ errors[0] }}</span>
            </div>
          </b-form-group>
        </validationProvider>
        <validationProvider
          v-slot="{ errors }"
          name="GP Standard"
          :rules="
            componentModel.level === 2
              ? {
                  validateNum2Decimal: true,
                  dynamicRequired: ['กรุณาระบุ GP Standard'],
                }
              : {}
          "
        >
          <b-form-group
            label="GP Standard (%)"
            label-for="input_gp_standard"
            label-cols-sm="3"
            v-if="componentModel.level === 2"
          >
            <b-form-input
              id="input_gp_standard"
              type="number"
              step=".01"
              v-model="componentModel.gp_standard"
              placeholder="ระบุ GP Standard"
              :class="{
                'is-invalid': errors && errors.length,
                'is-valid':
                  !(errors && errors.length) && componentModel.product_line,
              }"
            ></b-form-input>
            <div v-if="errors && errors.length" class="validate-invalid">
              <span>{{ errors[0] }}</span>
            </div>
          </b-form-group>
        </validationProvider>
        <b-form-group
          label="สำหรับสินค้าฟรี"
          label-for="input_is_free"
          label-cols-sm="3"
        >
          <div class="row col-sm-9 col-form-label">
            <b-form-radio
              v-model="componentModel.is_free"
              name="input_is_free"
              class="custom-control custom-radio custom-radio-info mb-3"
              :value="true"
              style="margin-right: 10px"
              >Yes</b-form-radio
            >
            <b-form-radio
              v-model="componentModel.is_free"
              name="input_is_free"
              class="custom-control custom-radio custom-radio-info mb-3"
              :value="false"
              >No</b-form-radio
            >
          </div>
        </b-form-group>
        <!-- <validationProvider
          v-slot="{ errors }"
          name="Status"
          :rules="{ dynamicRequired: ['กรุณาเลือกสถานะ'] }"
        > -->
        <b-form-group label="สถานะ" label-for="input_status" label-cols-sm="3">
          <div class="row col-sm-9 col-form-label">
            <basic-select
              :options="optionsStatus"
              :reload="reloadStatusSelector"
              :selected-option="{
                text: componentModel.status,
                value: componentModel.status,
              }"
              @select="onStatusSelector($event)"
              placeholder="ระบุสถานะ"
              v-bind:isError="isValidate.status"
              :disabled="!isStatusActiveParent"
            >
            </basic-select>
            <!-- <b-form-radio
                v-model="componentModel.status"
                name="input_status"
                class="custom-control custom-radio custom-radio-info mb-3"
                value="Active"
                style="margin-right: 10px"
                >Active</b-form-radio
              >
              <b-form-radio
                v-model="componentModel.status"
                name="input_status"
                class="custom-control custom-radio custom-radio-info mb-3"
                value="Inactive"
                style="margin-right: 10px"
                >Inactive</b-form-radio
              >
              <b-form-radio
                v-model="componentModel.status"
                name="input_status"
                class="custom-control custom-radio custom-radio-info mb-3"
                value="Delete"
                >Delete</b-form-radio
              > -->
          </div>
          <!-- <div v-if="errors && errors.length" class="validate-invalid">
              <span>{{ errors[0] }}</span>
            </div> -->
        </b-form-group>
        <!--  </validationProvider> -->
        <b-form-group
          label="สำหรับจัดการสินค้า"
          label-for="input_is_control_product"
          label-cols-sm="3"
        >
          <div class="row col-sm-9 col-form-label">
            <b-form-radio-group
              :disabled="componentModel.level !== lockLevel"
              v-model="componentModel.is_control_product"
              name="input_is_control_product"
            >
              <b-form-radio
                class="custom-control custom-radio custom-radio-info mb-3"
                :value="true"
                style="margin-right:10px;"
                >Yes</b-form-radio
              >
              <b-form-radio
                class="custom-control custom-radio custom-radio-info mb-3"
                :value="false"
                >No</b-form-radio
              >
            </b-form-radio-group>
          </div>
        </b-form-group>
        <div
          class="form-group row"
          v-if="componentModel.is_control_product === true"
        >
          <label class="col-form-label col-sm-3">Hybrid Category</label>
          <div class="col-sm-9">
            <div class="row">
              <div class="col-sm-10">
                <MappingHybridCategorySelector
                  :level="5"
                  :displayKey="`view_name`"
                  :idKey="`view_id`"
                  :childrenItemsKey="`items`"
                  :items="hybridCategoryItems"
                  :reload="isClearCategorySelector"
                  :isSelectLastChild="true"
                  @result="onHybridCategorySelector"
                  :height="200"
                ></MappingHybridCategorySelector>
              </div>
              <div class="col-sm-2">
                <button
                  v-if="componentModel.isSelectHybridCategory"
                  type="button"
                  class="btn btn-success waves-effect waves-light"
                  @click="onAddMappingHybridCategory"
                >
                  Add
                </button>
              </div>
            </div>
            <div class="row  mb-5">
              <div class="col-sm-12  mb-5">
                <div class="table-responsive mb-5">
                  <b-table
                    thead-class="d-none"
                    :borderless="true"
                    class="table table-centered"
                    ref="mappingHybridCategorytable"
                    :items="mappingHybridCategoryItems"
                    align="center"
                    v-bind:fields="fieldsEdit"
                  >
                    <template v-slot:cell(index)="data">
                      <div class="hybrid-list hybrid-success">
                        <b>{{ (data.index + 1) | number }}</b
                        >) {{ genHybridDisplay(data.item) }}
                      </div>
                    </template>
                    <template v-slot:cell(action)="data">
                      <div class="button-items align-middle">
                        <button
                          type="button"
                          class="btn btn-danger waves-effect waves-light"
                          title="Delete"
                          @click="onDeleteMappingHybridCategory(data.item.id)"
                        >
                          <i class="mdi mdi-trash-can label-icon"></i>
                        </button>
                      </div>
                    </template>
                  </b-table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </validationObserver>
  </div>
</template>

<script>
import { StatusEnum } from '@/enum/status.enum.js'
import { InventoryLockLevel } from '@/enum/inventory-category.enum.js'
import { FormatQty } from '@/helpers/utils/format-qty.js'
import { OptionDropdownStatus } from '@/helpers/utils/status.js'
import { BasicSelect } from 'vue-search-select'
import filecloudService from '@/helpers/service/filecloud-service'
import hybridCategoryService from '@/helpers/service/hybrid-category-service'
import inventoryCategoryService from '@/helpers/service/inventory-category-service'
import MappingHybridCategorySelector from '@/components/mappinghybridcategory/mapping-hybrid-category-selector'

export default {
  name: 'InventoryCategoryDetailEditor',
  components: {
    MappingHybridCategorySelector,
    'basic-select': BasicSelect,
  },
  props: {
    value: {
      type: Object,
      default: () => {
        return this.componentModel
      },
    },
    isChanged: {
      type: Boolean,
      default: () => {
        return false
      },
    },
    isStatus: {
      type: Boolean,
      default: () => {
        return false
      },
    },
  },
  mounted() {
    this.optionsStatus = OptionDropdownStatus
    this.getHybridCategory()
  },
  data() {
    return {
      componentModel: {
        root: null,
        id: null,
        parent_id: null,
        level: 0,
        code: null,
        display_name: {
          th: '',
          en: '',
        },
        product_line: null,
        gp_standard: null,
        type: null,
        status: StatusEnum.ACTIVE,
        is_free: false,
        is_control_product: false,
        mapping_hybrid_categories: [],
        mappingHybridCategoryItems: [],
        isSelectHybridCategory: false,
      },
      mappingHybridCategoryItems: [],
      componentModelOriginal: {},
      isValidate: {
        display_name_th: false,
        display_name_en: false,
        commission_rate: false,
        status: false,
      },
      optionsStatus: [],
      reloadStatusSelector: false,
      isShowEditImage: false,
      mappingHybridCategoryValue: null,
      isClearCategorySelector: false,
      firstRowOnPage: 1,
      fieldsEdit: [
        {
          key: 'index',
          tdStyle: 'max-width: 100px;',
        },
        {
          key: 'action',
          thStyle: 'width:80px',
        },
      ],
      hybridCategoryItems: [],
      lockLevel: InventoryLockLevel,
      canUpdateDeleteStatus: {
        isDelete: true,
        isConfirm: false,
      },
    }
  },
  computed: {
    isStatusActiveParent() {
      return (
        this.componentModel.parent_status === '' ||
        this.componentModel.parent_status === 'Active'
      )
    },
    // tests() {
    //   console.log(
    //     'componentModel.mappingHybridCategoryItems ',
    //     this.componentModel.mappingHybridCategoryItems
    //   )
    //   return this.componentModel.mappingHybridCategoryItems
    // },
  },
  created: function() {
    if (this.value) {
      this.componentModel = this.value
      this.componentModelOriginal = JSON.parse(JSON.stringify(this.value))
      this.getInventoryProductSku()
    }
  },
  watch: {
    value: {
      handler(val) {
        this.componentModel = val
      },
      deep: true,
    },
    'componentModel.is_control_product': {
      handler(val) {
        this.getHybridCategory()
      },
      deep: true,
    },
    'componentModel.mappingHybridCategoryItems': {
      handler(val) {
        this.mappingHybridCategoryItems = val
      },
      deep: true,
    },
    componentModel: {
      handler(val) {
        if (this.componentModelOriginal) {
          if (
            JSON.stringify(this.componentModel) !==
            JSON.stringify(this.componentModelOriginal)
          )
            this.$emit('update:isChanged', true)
          else this.$emit('update:isChanged', false)
        }
      },
      deep: true,
    },
  },
  methods: {
    async getInventoryProductSku() {
      var result = await inventoryCategoryService.getInventoryProductSkuListAsync(
        this.componentModel.id
      )
      if (result.status === 200) {
        console.log(result.data.skus)
        var countStatusProductDelete = 0
        var countStatusProductAnother = 0
        result.data.skus.forEach(element => {
          if (element.inventory_status === 'Delete') {
            countStatusProductDelete++
          } else {
            countStatusProductAnother++
          }
        })

        if (countStatusProductDelete === result.data.skus.length) {
          this.canUpdateDeleteStatus = {
            isDelete: true,
            isConfirm: true,
          }
        } else if (
          countStatusProductAnother === result.data.skus.length ||
          (countStatusProductAnother !== 0 && countStatusProductDelete !== 0)
        )
          this.canUpdateDeleteStatus = {
            isDelete: false,
            isConfirm: false,
          }
      }
    },
    async onValidateDisplaynameTH() {
      if (
        !(
          this.componentModel.display_name.th === undefined ||
          this.componentModel.display_name.th === null ||
          this.componentModel.display_name.th.trim() === '' ||
          this.componentModel.display_name.th.trim() === null ||
          this.componentModel.display_name.th.trim() === undefined
        )
      ) {
        if (
          this.componentModelOriginal.display_name.th ===
          this.componentModel.display_name.th
        ) {
          this.isValidate.display_name_th = false
          return
        }

        let params = new URLSearchParams()
        params.append('nameTH', this.componentModel.display_name.th.trim())
        params.append('id', this.componentModel.id)
        if (this.componentModel.parent_id !== null) {
          params.append('parent_id', this.componentModel.parent_id)
        }
        let result = await inventoryCategoryService.headInventoryCategoryAsync(
          params
        )
        if (result.status === 200) {
          this.isValidate.display_name_th = true
        } else if (
          (result.status && result.status === 404) ||
          (result.response.status && result.response.status === 404)
        ) {
          this.isValidate.display_name_th = false
        } else {
          if (result.response.data.message) {
            this.$utils.notification(
              'error',
              result.response.data.message,
              2000
            )
          } else {
            this.$utils.notification('error', 'Bad request: Unkonw error', 2000)
          }
        }
      }
    },
    async onValidateDisplaynameEN() {
      if (
        !(
          this.componentModel.display_name.en === undefined ||
          this.componentModel.display_name.en === null ||
          this.componentModel.display_name.en.trim() === '' ||
          this.componentModel.display_name.en.trim() === null ||
          this.componentModel.display_name.en.trim() === undefined
        )
      ) {
        if (
          this.componentModelOriginal.display_name.en ===
          this.componentModel.display_name.en
        ) {
          this.isValidate.display_name_en = false
          return
        }

        let params = new URLSearchParams()
        params.append('nameEN', this.componentModel.display_name.en.trim())
        params.append('id', this.componentModel.id)
        if (this.componentModel.parent_id !== null) {
          params.append('parent_id', this.componentModel.parent_id)
        }
        let result = await inventoryCategoryService.headInventoryCategoryAsync(
          params
        )
        if (result.status === 200) {
          this.isValidate.display_name_en = true
        } else if (
          (result.status && result.status === 404) ||
          (result.response.status && result.response.status === 404)
        ) {
          this.isValidate.display_name_en = false
        } else {
          if (result.response.data.message) {
            this.$utils.notification(
              'error',
              result.response.data.message,
              2000
            )
          } else {
            this.$utils.notification('error', 'Bad request: Unkonw error', 2000)
          }
        }
      }
    },
    async onStatusSelector(data) {
      this.isValidate.status = false
      this.reloadStatusSelector = false
      if (
        data.text === StatusEnum.DELETE &&
        this.canUpdateDeleteStatus.isDelete &&
        this.canUpdateDeleteStatus.isConfirm
      ) {
        this.$utils
          .confirmAlertDisplay(
            `ข้อมูลที่ถูก Delete จะไม่สามารถนำกลับมาใช้งานใหม่ได้ ต้องการ Delete ข้อมูลนี้ใช่หรือไม่`,
            ''
          )
          .then(result => {
            if (result) this.componentModel.status = data.text ? data.text : ''
          })
      } else if (
        data.text === StatusEnum.DELETE &&
        this.canUpdateDeleteStatus.isDelete &&
        !this.canUpdateDeleteStatus.isConfirm
      ) {
        this.componentModel.status = data.text ? data.text : ''
      } else if (
        data.text === StatusEnum.DELETE &&
        !this.canUpdateDeleteStatus.isDelete
      ) {
        this.$utils.notification(
          'warning',
          'มีสินค้าสถานะพร้อมขายอยู่ในหมวดหมู่นี้ ไม่สามารถปรับสถานะเป็น Delete ได้',
          2000
        )
      } else {
        this.componentModel.status = data.text ? data.text : ''
      }
    },
    async checkUploadImage() {
      var checkUpload = true
      var isUploadError = false
      if (
        this.componentModel.originalImg !== null &&
        this.componentModel.originalImg !== undefined
      ) {
        let dataOriginal = new FormData()
        dataOriginal.append(
          'file',
          this.componentModel.originalImg,
          `${this.componentModel.id}.jpg`
        )
        var uniq = '' + new Date().getTime()
        dataOriginal.append('bucket', `${process.env.VUE_APP_BUCKET_PIM}`)
        dataOriginal.append('path', `tmp/categories/original`)
        dataOriginal.append('key', `${uniq}.jpg`)
        dataOriginal.append('content_description', `pim-categories`)
        dataOriginal.append('is_upsert', true)
        let resultUploadOriginal = await filecloudService.uploadImageAsync(
          dataOriginal
        )
        if (resultUploadOriginal.status === 201) {
          var imgList = [
            {
              size: 'original',
              url: resultUploadOriginal.data.content_url,
            },
          ]
          this.componentModel.images = imgList
          checkUpload = true
        } else {
          checkUpload = false
          isUploadError = true
          this.$utils.notificationConfirm('error', 'ไม่สามารถ Upload รูปภาพ')
        }
      }
      return checkUpload && isUploadError === false
    },
    importImage(e) {
      var vm = this
      const file = e.target.files[0]
      if (file.type.match(/image.*/)) {
        var reader = new FileReader()
        reader.onload = function(readerEvent) {
          var image = new Image()
          image.onload = function(imageEvent) {
            if (
              40 <= Number(image.height) &&
              Number(image.height) <= 256 &&
              116 <= Number(image.width) &&
              Number(image.width) <= 256
            ) {
              var canvas = document.createElement('canvas')
              canvas.width = image.width
              canvas.height = image.height
              canvas
                .getContext('2d')
                .drawImage(image, 0, 0, image.width, image.height)
              var dataUrl = canvas.toDataURL('image/jpeg')
              var resizedImage = vm.dataURLToBlob(dataUrl)

              // vm.componentModel.urlImg = dataUrl
              vm.$set(vm.componentModel, 'urlImg', dataUrl)
              vm.componentModel.originalImg = resizedImage
              vm.isShowEditImage = true
            } else {
              vm.componentModel.file = null
              vm.componentModel.originalImg = null
              vm.componentModel.urlImg = null
              vm.$utils.notification('error', 'ขนาดรูปไม่เหมาะสม', 2000)
            }
          }
          image.src = readerEvent.target.result
        }
        reader.readAsDataURL(file)
      }
    },
    dataURLToBlob(dataURL) {
      let BASE64_MARKER = ';base64,'
      if (dataURL.indexOf(BASE64_MARKER) == -1) {
        let parts = dataURL.split(',')
        let contentType = parts[0].split(':')[1]
        let raw = parts[1]

        return new Blob([raw], { type: contentType })
      }

      let parts = dataURL.split(BASE64_MARKER)
      let contentType = parts[0].split(':')[1]
      let raw = window.atob(parts[1])
      let rawLength = raw.length

      let uInt8Array = new Uint8Array(rawLength)

      for (let i = 0; i < rawLength; ++i) {
        uInt8Array[i] = raw.charCodeAt(i)
      }

      return new Blob([uInt8Array], { type: contentType })
    },
    onValidateCommissionRate() {
      if (
        !(
          this.componentModel.commission_rate.trim() === '' ||
          this.componentModel.commission_rate.trim() === null ||
          this.componentModel.commission_rate.trim() === undefined
        )
      ) {
        if (Number(this.componentModel.commission_rate.trim()) > 100) {
          this.isValidate.commission_rate = true
        } else {
          this.isValidate.commission_rate = false
        }
      }
    },
    onHybridCategorySelector(obj) {
      this.mappingHybridCategoryValue = obj.id

      this.$set(this.componentModel, 'isSelectHybridCategory', obj.isSuccess)
      // this.componentModel.isSelectHybridCategory = obj.isSuccess
    },
    async onAddMappingHybridCategory() {
      if (
        this.mappingHybridCategoryValue !== null &&
        this.mappingHybridCategoryItems.findIndex(
          element => element.id === this.mappingHybridCategoryValue
        ) === -1
      ) {
        let params = new URLSearchParams()
        params.append('pageSize', 999)
        params.append('id', this.mappingHybridCategoryValue)
        let result = await hybridCategoryService.getHybridCategoryListAsync(
          params
        )
        if (result.status === 200) {
          // console.log('result.data.items[0]', result.data.items[0])
          this.mappingHybridCategoryItems.push(result.data.items[0])
          this.$set(
            this.componentModel,
            'mappingHybridCategoryItems',
            this.mappingHybridCategoryItems
          )
          this.checkMappingHybridCategoryChange()
          this.isClearCategorySelector = !this.isClearCategorySelector
          this.onHybridChanged()
        } else if (
          (result.status && result.status === 404) ||
          (result.response.status && result.response.status === 404)
        ) {
          console.log('error', result.response.data.message)
        } else {
          this.$utils.notification('error', result.response.data.message, 2000)
        }
      } else {
        this.$utils.notification('error', 'มีการ Add ข้อมูลนี้ไปแล้ว', 2000)
      }
    },
    onDeleteMappingHybridCategory(id) {
      // this.mappingHybridCategoryItems = []
      // this.componentModel = {}

      this.mappingHybridCategoryItems.splice(
        this.mappingHybridCategoryItems.findIndex(element => element.id === id),
        1
      )
      this.checkMappingHybridCategoryChange()
      this.onHybridChanged()
    },
    genHybridDisplay(input) {
      var result = `${input.display_name_level_1.th}(${input.code_level_1})`
      if (input.code_level_2)
        result += ` > ${input.display_name_level_2.th}(${input.code_level_2})`
      if (input.code_level_3)
        result += ` > ${input.display_name_level_3.th}(${input.code_level_3})`
      if (input.code_level_4)
        result += ` > ${input.display_name_level_4.th}(${input.code_level_4})`
      if (input.code_level_5)
        result += ` > ${input.display_name_level_5.th}(${input.code_level_5})`
      return result
    },
    checkMappingHybridCategoryChange() {
      if (this.componentModelOriginal) {
        if (
          JSON.stringify(this.mappingHybridCategoryItems) !==
          JSON.stringify(this.componentModelOriginal.mappingHybridCategoryItems)
        )
          this.$emit('update:isChanged', true)
        else this.$emit('update:isChanged', false)
      }
    },
    async getHybridCategory() {
      let params = new URLSearchParams()
      if (this.isStatus) {
        params.append('status', StatusEnum.ACTIVE)
        params.append('status', StatusEnum.INACTIVE)
      }
      params.append('isControlProduct', true)
      let result = await hybridCategoryService.getMappingHybridCategoryTreeNodeAsync(
        params
      )
      if (result.status === 200) {
        if (result.data.length) {
          this.hybridCategoryItems = result.data
        }
      }
    },
    onHybridChanged() {
      this.componentModel.mapping_hybrid_categories = []
      if (this.componentModel.is_control_product === true) {
        this.mappingHybridCategoryItems.forEach(element => {
          let tempParentItems = []
          if (element.level === 1) {
            let mapping_hybrid_categories = {
              hybrid_category_id: element.id,
              hybrid_parent_id: null,
              hybrid_code: element.code_level_1,
              hybrid_level: 1,
              hybrid_category_display_name: {
                th: element.display_name.th,
                en: element.display_name.en,
              },
              hybrid_parent_categories: tempParentItems,
            }
            this.componentModel.mapping_hybrid_categories.push(
              mapping_hybrid_categories
            )
          } else if (element.level === 2) {
            let tempParentLevel1 = {
              pim_id: element.id_level_1,
              parent_id: null,
              code: element.code_level_1,
              level: 1,
              display_name: {
                th: element.display_name_level_1.th,
                en: element.display_name_level_1.en,
              },
            }
            tempParentItems.push(tempParentLevel1)
            let mapping_hybrid_categories = {
              hybrid_category_id: element.id,
              hybrid_parent_id: element.id_level_1,
              hybrid_code: element.code_level_2,
              hybrid_level: 2,
              hybrid_category_display_name: {
                th: element.display_name.th,
                en: element.display_name.en,
              },
              hybrid_parent_categories: tempParentItems,
            }
            this.componentModel.mapping_hybrid_categories.push(
              mapping_hybrid_categories
            )
          } else if (element.level === 3) {
            let tempParentLevel1 = {
              pim_id: element.id_level_1,
              parent_id: null,
              code: element.code_level_1,
              level: 1,
              display_name: {
                th: element.display_name_level_1.th,
                en: element.display_name_level_1.en,
              },
            }
            tempParentItems.push(tempParentLevel1)
            let tempParentLevel2 = {
              pim_id: element.id_level_2,
              parent_id: element.id_level_1,
              code: element.code_level_2,
              level: 2,
              display_name: {
                th: element.display_name_level_2.th,
                en: element.display_name_level_2.en,
              },
            }
            tempParentItems.push(tempParentLevel2)
            let mapping_hybrid_categories = {
              hybrid_category_id: element.id,
              hybrid_parent_id: element.id_level_2,
              hybrid_code: element.code_level_3,
              hybrid_level: 3,
              hybrid_category_display_name: {
                th: element.display_name.th,
                en: element.display_name.en,
              },
              hybrid_parent_categories: tempParentItems,
            }
            this.componentModel.mapping_hybrid_categories.push(
              mapping_hybrid_categories
            )
          } else if (element.level === 4) {
            let tempParentLevel1 = {
              pim_id: element.id_level_1,
              parent_id: null,
              code: element.code_level_1,
              level: 1,
              display_name: {
                th: element.display_name_level_1.th,
                en: element.display_name_level_1.en,
              },
            }
            tempParentItems.push(tempParentLevel1)
            let tempParentLevel2 = {
              pim_id: element.id_level_2,
              parent_id: element.id_level_1,
              code: element.code_level_2,
              level: 2,
              display_name: {
                th: element.display_name_level_2.th,
                en: element.display_name_level_2.en,
              },
            }
            tempParentItems.push(tempParentLevel2)
            let tempParentLevel3 = {
              pim_id: element.id_level_3,
              parent_id: element.id_level_2,
              code: element.code_level_3,
              level: 3,
              display_name: {
                th: element.display_name_level_3.th,
                en: element.display_name_level_3.en,
              },
            }
            tempParentItems.push(tempParentLevel3)
            let mapping_hybrid_categories = {
              hybrid_category_id: element.id,
              hybrid_parent_id: element.id_level_3,
              hybrid_code: element.code_level_4,
              hybrid_level: 4,
              hybrid_category_display_name: {
                th: element.display_name.th,
                en: element.display_name.en,
              },
              hybrid_parent_categories: tempParentItems,
            }
            this.componentModel.mapping_hybrid_categories.push(
              mapping_hybrid_categories
            )
          } else if (element.level === 5) {
            let tempParentLevel1 = {
              pim_id: element.id_level_1,
              parent_id: null,
              code: element.code_level_1,
              level: 1,
              display_name: {
                th: element.display_name_level_1.th,
                en: element.display_name_level_1.en,
              },
            }
            tempParentItems.push(tempParentLevel1)
            let tempParentLevel2 = {
              pim_id: element.id_level_2,
              parent_id: element.id_level_1,
              code: element.code_level_2,
              level: 2,
              display_name: {
                th: element.display_name_level_2.th,
                en: element.display_name_level_2.en,
              },
            }
            tempParentItems.push(tempParentLevel2)
            let tempParentLevel3 = {
              pim_id: element.id_level_3,
              parent_id: element.id_level_2,
              code: element.code_level_3,
              level: 3,
              display_name: {
                th: element.display_name_level_3.th,
                en: element.display_name_level_3.en,
              },
            }
            tempParentItems.push(tempParentLevel3)
            let tempParentLevel4 = {
              pim_id: element.id_level_4,
              parent_id: element.id_level_3,
              code: element.code_level_4,
              level: 4,
              display_name: {
                th: element.display_name_level_4.th,
                en: element.display_name_level_4.en,
              },
            }
            tempParentItems.push(tempParentLevel4)
            let mapping_hybrid_categories = {
              hybrid_category_id: element.id,
              hybrid_parent_id: element.id_level_4,
              hybrid_code: element.code_level_5,
              hybrid_level: 5,
              hybrid_category_display_name: {
                th: element.display_name.th,
                en: element.display_name.en,
              },
              hybrid_parent_categories: tempParentItems,
            }
            this.componentModel.mapping_hybrid_categories.push(
              mapping_hybrid_categories
            )
          }
        })
      }
    },
  },
}
</script>
